import { render, staticRenderFns } from "./RecaptchaInput.vue?vue&type=template&id=519a074a&"
import script from "./RecaptchaInputVue.ts?vue&type=script&lang=ts&"
export * from "./RecaptchaInputVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports